module.exports = __webpack_public_path__ + "img/soft-grove-kitchen-5.208cf91c.jpeg";